import React, { useContext } from "react";
export const BlockEditV2Context = React.createContext(null);
export const useBlockEditV2Context = () => useContext(BlockEditV2Context);
